import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import clsx from 'clsx';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';

import Cell from './Cell';
import { MAIN_COLUMN_ID } from './columns';
import { useStyles } from './styles';

const Loader = () => {
  const classes = useStyles();
  return (
    <tr>
      <td className={classes.loadingRow} colSpan="100%">
        <LinearProgress />
      </td>
    </tr>
  );
};

const ExpandedDataTable = ({ columns, data }) => {
  const classes = useStyles();

  return data.map(recruiter => (
    <TableRow key={recruiter.id} className={classes.rowColor}>
      <TableCell aria-label="Empty action button" className={classes.commonCell} />

      {columns.map(col => (
        <Cell
          key={col.id}
          className={clsx({
            [classes.commonCell]: true,
            [classes.stickyColumn]: col.id === MAIN_COLUMN_ID,
            [classes.recruiter]: col.id === MAIN_COLUMN_ID
          })}
          mainLabel={recruiter[col?.id === MAIN_COLUMN_ID ? 'recruiter' : col.id]}
          secondaryLabel={col?.subLabelId && recruiter[col.subLabelId]}
        />
      ))}
    </TableRow>
  ));
};

export const ExpandableRow = ({ columns, endpoint }) => {
  const { Status } = useFetchWithStatusV2({
    endpoint,
    apiInstance: SECONDARY_API_CLIENT
  });
  return (
    <Status
      loading={<Loader />}
      success={data => <ExpandedDataTable columns={columns} data={data} />}
    />
  );
};
